<table
  (matSortChange)="onSort($event)"
  [dataSource]="dataSource"
  appResizableColumn
  mat-table
  matSort>
  <ng-container
    *ngFor="let column of tableColumns$ | async"
    matColumnDef="{{ column.name }}">
    <th
      (mousedown)="onColumnResize($event, column.name)"
      *matHeaderCellDef
      class="admia-table-resizable"
      mat-header-cell
      mat-sort-header>
      {{ column.text | translate }}
    </th>
    <td *matCellDef="let material" mat-cell>
      <div *ngIf="column.name === columns.Date" class="cell-content">
        {{ material.date | date: 'mediumDate' }}
      </div>

      <div *ngIf="column.name === columns.Total" class="cell-content">
        {{ (material?.price * material?.quantity).toFixed(2) }}
      </div>

      <div *ngIf="column.name.includes('person')" class="cell-content">
        {{ material['person'][column.name.replace('person.', '')] }}
      </div>

      <div
        *ngIf="
          column.name !== columns.Date &&
          column.name !== columns.Total &&
          !column.name.includes('person')
        "
        class="cell-content">
        {{ material[column.name] }}
      </div>
    </td>
  </ng-container>

  <tr
    #materialHeader
    *matHeaderRowDef="displayedColumns; sticky: true"
    class="admia-table-header-row"
    mat-header-row>
  </tr>

  <tr
    #materialRow
    (click)="onClick(i)"
    (dblclick)="onDoubleClick(i)"
    *matRowDef="let row; columns: displayedColumns; let i = index"
    [ngClass]="{
      'selected-item': i === (selectedIndex$ | async),
      'not-selectable-item':
        !row?.authorisation?.edit && i !== (selectedIndex$ | async)
    }"
    class="admia-table-row"
    mat-row>
  </tr>
</table>
